// Single source of truth for the "what we help with" directory on /how-we-help.
//
// Every specialty / concern / identity / couples page is listed here once, in a
// group. The How We Help hub renders this directory, and Navigation uses
// SPECIALTY_PATHS to highlight "How We Help" as active on any specialty page —
// so the long list of pages lives in ONE place instead of being hand-copied
// into the nav dropdown, the footer, and the hub separately.
//
// When you add a new specialty page (see the page-wiring runbook), add it here
// and it appears on the hub and gets correct nav highlighting automatically.

export const SPECIALTY_DIRECTORY = [
  {
    id: 'concerns',
    title: 'Concerns we work with',
    blurb: 'Individual therapy for what brings people in most often.',
    links: [
      { label: 'Anxiety', href: '/anxiety-therapy-new-york' },
      { label: 'Depression', href: '/depression-therapy-new-york' },
      { label: 'Trauma', href: '/trauma-therapy-new-york' },
      { label: 'Burnout', href: '/burnout-therapy-new-york' },
      { label: 'OCD', href: '/ocd-therapy-new-york' },
      { label: 'Grief & Loss', href: '/grief-therapy-new-york' },
      { label: 'Perinatal & Postpartum', href: '/perinatal-postpartum-therapy-new-york' },
      { label: 'Self-Esteem', href: '/self-esteem-therapy-new-york' },
      { label: 'Life Transitions', href: '/life-transitions-therapy-new-york' },
    ],
  },
  {
    id: 'identity',
    title: 'Identity & affirming care',
    blurb: 'Care that already understands the context you carry.',
    links: [
      { label: 'Culturally Responsive Care', href: '/culturally-responsive-therapy' },
      { label: 'LGBTQIA+ Affirming Therapy', href: '/lgbtqia-affirming-therapy' },
      { label: 'Gender-Affirming Therapy', href: '/gender-affirming-therapy-new-york' },
      { label: 'Neurodivergent-Affirming Therapy', href: '/neurodivergent-affirming-therapy-new-york' },
      { label: 'ENM, Poly & Relationship Diversity', href: '/enm-poly-therapy' },
      { label: 'Therapy in Spanish (Español)', href: '/spanish-speaking-therapy-new-york' },
      { label: 'Bilingual & Bicultural Therapy', href: '/bilingual-therapy-new-york' },
      { label: 'First-Generation Therapy', href: '/first-generation-therapy-new-york' },
      { label: 'Religious Trauma & Spirituality', href: '/religious-trauma-therapy-new-york' },
    ],
  },
  {
    id: 'relationships',
    title: 'Couples & relationships',
    blurb: 'Support for partners and relationships of many kinds.',
    links: [
      { label: 'Couples & Relationship Therapy', href: '/couples-relationship-therapy' },
      { label: 'Communication & Conflict', href: '/couples-therapy-communication-new-york' },
      { label: 'Relationship Anxiety', href: '/relationship-anxiety-therapy-new-york' },
      { label: 'LGBTQIA+ Couples Therapy', href: '/lgbtq-couples-therapy-new-york' },
      { label: 'Polyamory-Affirming Couples', href: '/polyamory-affirming-couples-therapy-new-york' },
    ],
  },
  {
    id: 'approaches',
    title: 'How we work',
    blurb: 'Specific approaches our clinicians are trained in, alongside the relational work.',
    links: [
      { label: 'EMDR Therapy', href: '/emdr-therapy-new-york' },
      { label: 'DBT Therapy', href: '/dbt-therapy-new-york' },
    ],
  },
];

// Flat list of every specialty page path. Navigation uses this to mark
// "How We Help" active on any specialty page without a giant hand-maintained list.
export const SPECIALTY_PATHS = SPECIALTY_DIRECTORY.flatMap((group) =>
  group.links.map((link) => link.href),
);
